<template>
    <div>
        <b-modal v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Projeto - Anexo -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Tipo do Anexo</label>
                        <b-form-select
                            :plain="true"
                            :options="tiposAnexosSelect"
                            v-model="tipoId"
                            text-field="descricao"
                            value-field="anexoTipoId"
                        ></b-form-select>
                    </b-form-group>
                    <b-alert show v-if="tipo && tipo.ajuda">{{
                        tipo.ajuda
                    }}</b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descritivo</label>
                        <b-form-input
                            type="text"
                            placeholder="Descritivo"
                            v-model="descritivo"
                            @input="$v.descritivo.$touch()"
                            :state="$v.descritivo.$error ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O descritivo do anexo é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharAnexoForm()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="salvarAnexo()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        projeto: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'INSERIR',
            erros: [],
            obterAnexosAtualizados: false,
            tiposAnexosSelect: [],
            tipoId: '',
            descritivo: '',
            arquivo: null
        }
    },

    methods: {
        fecharAnexoForm() {
            this.mostrarModal = false
            this.resetAnexoForm()
            if (this.obterAnexosAtualizados) {
                this.$emit('obterAnexosAtualizados')
            }
        },

        resetAnexoForm() {
            this.descritivo = ''
            this.tipoId = ''
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterAnexosAtualizados = false
        },

        salvarAnexo() {
            this.mostrarModal = false
            this.$store.dispatch('addRequest')
            if (this.operacao === 'INSERIR') {
                let anexoData = {
                    codProjeto: this.projeto.codProjeto,
                    projetoId: this.projeto.projetoId,
                    tipoId: this.tipoId,
                    descritivo: this.descritivo,
                    arquivo: this.arquivo
                }
                this.servicos.inserirAnexo(anexoData).then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterAnexosAtualizados = true
                            this.resetAnexoForm()
                            this.fecharAnexoForm()
                        } else {
                            this.erros = response.errors
                            this.mostrarModal = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterAnexosTipos() {
            this.$store.dispatch('addRequest')
            this.servicos.obterAnexosTipos(this.projeto.projetoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposAnexosSelect = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter tipos de anexos!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        if (this.$temAcesso('SGTEC-PROJ-ANX-01')) {
            this.obterAnexosTipos()
        }
    },

    computed: {
        tipo() {
            let tiposTemp = this.tiposAnexosSelect.find(
                p => p.anexoTipoId == this.tipoId
            )
            return tiposTemp ? tiposTemp : {}
        }
    },

    validations: {
        tipoId: {
            required
        },
        arquivo: {
            required
        },
        descritivo: {
            required
        }
    }
}
</script>
